// redux/slices/toasterSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ToasterState {
    message: string;
    type: "success" | "error" | null;
}

const initialState: ToasterState = {
    message: "",
    type: null,
};

const toasterSlice = createSlice({
    name: "toaster",
    initialState,
    reducers: {
        showToaster: (
            state,
            action: PayloadAction<{ message: string; type: "success" | "error" }>
        ) => {
            state.message = action.payload.message;
            state.type = action.payload.type;
        },
        hideToaster: (state) => {
            state.message = "";
            state.type = null;
        },
    },
});

export const { showToaster, hideToaster } = toasterSlice.actions;

export default toasterSlice.reducer;
